<template>
  <Loader v-if="isShowLoader"/>
  <div class="sky">
    <div class="grid grid-cols-12 bg-form">
    <!-- left side -->
    <div class="col-span-12 lg:col-span-6 left-column" style="">
      <div class="text-center px-4 flex flex-col h-full">
        <img class="mx-auto" :src="projectSettings?.logo || require('@/assets/gen-logo.png')" alt="" width="135" height="87">
        <h1 class="text-white mt-5">
          <span class="inter inter-600 text-2xl xl:text-[32px] leading-10">Help a Friend Find Their </span>
          <span class="caveat text-[36px] xl:text-[49px] leading-[60px]">Dream&nbsp;Home</span>
        </h1>
        <label for="phone" class="text-white inter inter-500 text-base flex items-center gap-2 justify-center cursor-pointer">
          <span>Fill in the form to refer a friend</span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.8462 17.6538L12.7923 16.5693L16.6115 12.75H1.5V11.25H16.6115L12.7923 7.43075L13.8462 6.34625L19.5 12L13.8462 17.6538Z" fill="white"/>
          </svg>
        </label>
        <!-- <div class="mt-4 line-gradient mb-10"></div>
        <img src="../assets/building.png" class="mx-auto mt-auto building pr-7 lg:mb-10" alt=""> -->
      </div>
    </div>

    <!-- Right side -->
    <div class="col-span-12 lg:col-span-6 px-0 sm:px-12 lg:pl-0 lg:pt-10 sm:pb-5 lg:min-h-[100vh] bg-[#101010] lg:bg-transparent">
      <form class="bg-white sm:rounded-[14px] border border-[#E6E6E6] pt-7 shadow-md" @submit.prevent="generateOTP()">
        <div class="inter inter-600 pb-3 mb-6 border-b px-5 sm:px-0 sm:mx-7">
          Your Information
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 px-5 sm:px-7">
          <div class="col-span-1 md:pr-3 mb-5">
            <label class="block mb-3 text-[#333333] inter inter-400 text-sm" for="name">Phone Number <span class="text-red-500">*</span></label>
            <v-select 
                v-model="selectedNumber"
                :options="autocompleteItems"
                :dropdown-should-open="dropdownShouldOpen"
                @input="throwSuggestions($event)"
                label="phone"
                inputId="phone"
                :taggable="true"
                placeholder="Phone number"
                @keypress="preventNonNumeric">
              <template #search="{attributes, events}">
                <input
                  @input=""
                  maxlength="13"
                  class="vs__search"
                  :required="!selected"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
              <template #no-options="{ search, searching, loading }">
                <span class="text-xs inter inter-500 text-[#333] text-opacity-50">Please enter your phone number</span>
              </template>
            </v-select>
          </div>
          <div class="col-span-1 md:pl-3 mb-5">
            <label class="block mb-3 text-[#333333] inter inter-400 text-sm" for="name">Full Name</label>
            <input required v-model="selectedName" :disabled="!disableText" class="rounded border border-[#CCCCCC] inter inter-400 text-sm block w-full p-3 leading-[16px] ring-[#5580A0] focus:border-[#5580A0] focus:ring-[#5580A0] focus-visible::border-[#5580A0] focus-visible::ring-[#5580A0] transition-all"
              type="text" name="name" id="name"  placeholder="Full Name">
          </div>
        </div>
        <div class="inter inter-600 pb-3 mb-6 border-b px-5 sm:px-0 sm:mx-7">
          Referral’s Information 
        </div>
        <!-- loop section starts -->
        <div class="referral-wrapper">
          <template v-for="(lead, index) in referralLeads" :key="index">
            <div class="grid grid-cols-1 md:grid-cols-2 px-5 sm:px-7 relative">
              <div class="col-span-1 md:pr-3 mb-5">
                <label class="block mb-3 text-[#333333] inter inter-400 text-sm" :for="`ref-name-${index}`">{{index == 0 ? 'Referral Name' : `${index + 1} Referral Name`}} <span class="text-red-500">*</span></label>
                <input required class="rounded border border-[#CCCCCC] inter inter-400 text-sm block w-full p-3 leading-[16px] ring-[#5580A0] focus:border-[#5580A0] focus:ring-[#5580A0] focus-visible::border-[#5580A0] focus-visible::ring-[#5580A0] transition-all"
                  type="text" :name="`ref-name-${index}`" v-model.trim="lead.full_name" :id="`ref-name-${index}`"  placeholder="Full Name">
              </div>
              <div class="col-span-1 md:pl-3 mb-5">
                <label class="block mb-3 text-[#333333] inter inter-400 text-sm" :for="`ref-mob-${index}`">Phone Number <span class="text-red-500">*</span></label>
                <input @input="validateInput(index)" required @keypress="preventNonNumeric" class="rounded border border-[#CCCCCC] inter inter-400 text-sm block w-full p-3 leading-[16px] ring-[#5580A0] focus:border-[#5580A0] focus:ring-[#5580A0] focus-visible::border-[#5580A0] focus-visible::ring-[#5580A0] transition-all"
                  type="text" :name="`ref-mob-${index}`" v-model.trim="lead.primary_phone" :id="`ref-mob-${index}`" placeholder="Phone Number">
              </div>
              <button v-show="index > 0" type="button" @click="removeReferralLead(index)" class="p-0.5 bg-transparent border-0 absolute rounded-full btn-remove">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4166 8.50004C16.4166 12.8724 12.8723 16.4167 8.49992 16.4167C4.12754 16.4167 0.583252 12.8724 0.583252 8.50004C0.583252 4.12767 4.12754 0.583374 8.49992 0.583374C12.8723 0.583374 16.4166 4.12767 16.4166 8.50004ZM6.10117 6.10129C6.2125 5.9901 6.36341 5.92765 6.52075 5.92765C6.6781 5.92765 6.82901 5.9901 6.94033 6.10129L8.49992 7.66087L10.0595 6.10129C10.1721 5.99641 10.3209 5.93931 10.4747 5.94203C10.6286 5.94474 10.7753 6.00705 10.8841 6.11584C10.9929 6.22463 11.0552 6.37139 11.0579 6.52521C11.0606 6.67903 11.0035 6.8279 10.8987 6.94046L9.33909 8.50004L10.8987 10.0596C11.0035 10.1722 11.0606 10.321 11.0579 10.4749C11.0552 10.6287 10.9929 10.7755 10.8841 10.8842C10.7753 10.993 10.6286 11.0553 10.4747 11.0581C10.3209 11.0608 10.1721 11.0037 10.0595 10.8988L8.49992 9.33921L6.94033 10.8988C6.82778 11.0037 6.67891 11.0608 6.52509 11.0581C6.37127 11.0553 6.2245 10.993 6.11572 10.8842C6.00693 10.7755 5.94462 10.6287 5.9419 10.4749C5.93919 10.321 5.99629 10.1722 6.10117 10.0596L7.66075 8.50004L6.10117 6.94046C5.98998 6.82913 5.92752 6.67822 5.92752 6.52087C5.92752 6.36353 5.98998 6.21262 6.10117 6.10129Z" fill="#D2D6DE"/>
                </svg>
              </button>
            </div>
          </template>
        </div>
        <div class="px-5 sm:px-7 mb-7">
          <button @click="addReferralLead" type="button" class="inter inter-500 inline-flex items-center gap-1.5 text-[#5580A0] text-sm py-2.5 px-5 border border-current rounded bg-[#5580A0] bg-opacity-10 hover:bg-opacity-15 transition-all">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 7.00012H11M7 3.00012V11.0001" stroke="#5580A0" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <span>Add Referral</span>
          </button>
        </div>
        <!-- loop section ends -->
        
        <div class="text-center px-5 sm:px-7 pb-7 bg-white rounded-[14px] border-top">
          <button type="submit" class="w-full md:w-auto rounded inter inter-600 text-sm text-white leading-[18px] py-3.5 px-10 bg-[#5580A0] mx-auto">Submit Referral</button>
          <div class="inter inter-400 text-[11px] text-[#999999] mt-4">I authorize PROPERTY PISTOL REALTY PRIVATE LIMITED and its representatives to Call, SMS, Email or WhatsApp me about its products and offers. This consent overrides any registration for DNC/NDNC.</div>
        </div>
      </form>
    </div>
    <div class="foreground"></div>
    <div>
      <Transition name="backdrop">
        <div class="fixed z-30 bg-black bg-opacity-50 w-full h-full left-0 top-0 backdrop-blur-lg" v-if="isOtpModalOpen"></div>
      </Transition>
      <Transition name="modalContent">
      <div class="inter fixed z-40 w-full h-full left-0 top-0 flex flex-col gap-4 items-center justify-center p-4" v-if="isOtpModalOpen">
        <Transition name="modalContent">
          <div class="rounded-lg bg-white p-7 shadow w-full max-w-[480px] min-w-80 relative" v-if="!showResponse">
            <button @click="closeModal" class="absolute right-5 top-5 bg-gray-900 bg-opacity-0 p-2 rounded-full text-[#D9D9D9] hover:text-white hover:bg-opacity-20 transition-all" type="button">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.33317 11.8333L0.166504 10.6666L4.83317 5.99998L0.166504 1.33331L1.33317 0.166641L5.99984 4.83331L10.6665 0.166641L11.8332 1.33331L7.16651 5.99998L11.8332 10.6666L10.6665 11.8333L5.99984 7.16664L1.33317 11.8333Z" fill="currentColor"/>
              </svg>
            </button>
            <div class="inter-600 text-[#333333] mb-5">
              OTP Verification
            </div>
            <div class="mb-10">
              <span class="text-sm text-[#999] text-opacity-75">OTP was sent to</span> &nbsp;
              <span class="inter-500 text-[#333333] text-opacity-80">{{selectedNumber?.phone ?? selectedNumber}}</span> &nbsp;
              <button class="text-[#5580A0] text-xs inter-500" type="button" @click="generateOTP('resend')">
                Resend OTP
              </button>
            </div>
            <div class="mb-10">
              <v-otp-input
                ref="otpInput"
                input-classes="otp-input"
                :conditionalClass="['one', 'two', 'three', 'four']"
                separator=""
                :input-attributes="{ inputmode: 'tel' }"
                :num-inputs="6"
                :should-auto-focus="true"
                :should-focus-order="true"
                :placeholder="['-', '-', '-', '-', '-', '-']"
                @on-complete="handleOnComplete"
                :inputType="'number'"
                @keypress="preventNonNumeric"
              />
            </div>
            <button type="button" @click="validateOtp" class="block rounded inter inter-600 text-sm text-white leading-[18px] py-3.5 px-10 mb-2.5 bg-[#5580A0] mx-auto">Proceed</button>
          </div>
        </Transition>
        <Transition name="modalContent">
            <div class="rounded-lg bg-white p-7 shadow w-full max-w-[480px] min-w-80 relative text-center" v-if="showResponse">
              <button @click="closeModal" class="absolute right-5 top-5 bg-gray-900 bg-opacity-0 p-2 rounded-full text-[#D9D9D9] hover:text-white hover:bg-opacity-20 transition-all" type="button">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.33317 11.8333L0.166504 10.6666L4.83317 5.99998L0.166504 1.33331L1.33317 0.166641L5.99984 4.83331L10.6665 0.166641L11.8332 1.33331L7.16651 5.99998L11.8332 10.6666L10.6665 11.8333L5.99984 7.16664L1.33317 11.8333Z" fill="currentColor"/>
                </svg>
              </button>
              <img class="mx-auto mb-7 mt-2.5" src="../assets/success.gif" width="90" height="90" alt="">
              <div class="inter inter-600 text-2xl text-[#333333] mb-4">
                Thank you so much for the referral!
              </div>
              <div class="inter text-[#555555] mb-7">
                We really appreciate your support and consideration.
              </div>
            </div>
          </Transition>
          </div>
        </Transition>
    </div>
  </div>
  </div>
</template>
  
<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import Loader from './Loader.vue';
export default {
  emits: ['startLoad', 'stopLoad'],
  components:{
    vSelect,
    Loader
  },
  mounted(){
    this.getSettings();
  },
  data() {
    return {
      otp: '',
      isOtpModalOpen: false,
      showResponse: false,
      projectSettings:"",
      selectedNumber:"",
      selectedName:"",
      autocompleteItems:[],
      referralLeads: [
        { full_name: "", primary_phone: "" }
      ],
      isShowLoader:false,
      selected:false
    }
  },
  watch:{
    selectedNumber: {
    handler(newVal, oldVal) {
      this.selectedName = newVal?.name || null;
      this.selected = !!newVal;
    },
    immediate: true
  },
  },
  computed:{
    disableText(){
      if (this.selectedNumber && this.autocompleteItems.length == 0) {
        return true;
      }else
      return false
    }
  },
  methods: {
    handleOnComplete(value) {
      this.otp = value;
    },
    preventNonNumeric(event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    handleOnChange(value){
      value.replace(/\D/g, "");
    },
    closeModal(){
      this.isOtpModalOpen = false;
      this.showResponse = false;
    },
    openModal(){
      this.isOtpModalOpen = true;
    },
    addReferralLead() {
      if (this.referralLeads.length < 10) {
        this.referralLeads.push({ full_name: "", primary_phone: "" });
      }
    },
    removeReferralLead(index) {
      this.referralLeads.splice(index, 1);
    },
    generateOTP(resend) {
      this.isShowLoader = true;
      this.$axios.post(`customer_referral/leads/send_otp?phone=${this.selectedNumber?.phone ?? this.selectedNumber}`).then((response) => {
        if (!resend) {
          this.openModal();
        }
        this.isShowLoader = false;
      }).catch(err => {
        console.log(err);
        if (err.response.status === 500) {
          this.$swal({
            title: "Server Error!",
            icon: "error"
          });
        } else {
          this.$swal({
            title: "Error",
            text: err.response.data.message,
            icon: "error"
          });
        }
       this.isShowLoader = false;
      })
    },
    validateOtp() {
      this.isShowLoader = true;
      this.$axios.post(`customer_referral/leads/verify_otp`, {
        "otp": this.otp
      }).then((res) => {
        if (res?.data?.success && res?.data?.otp_uuid) {
          this.createLead(res.data.otp_uuid);
          this.$refs.otpInput.clearInput();
        }
      }).catch(err => {
        this.isShowLoader = false;
        if (err.response.status === 500) {
          this.$swal({
            title: "Server Error!",
            icon: "error"
          });
        } else {
          this.$refs.otpInput.clearInput();
          this.$swal({
            title: "Error",
            text: err.response.data.message,
            icon: "error"
          });
        }
      })
    },
    async getSettings() {
      this.$emit('startLoad');
      const domainUrl = window.location.host;
      try {
        const res = await this.$axios.get(`customer_referral/leads/settings?domain=${domainUrl}`);
        if (res.status === 200 && res.data) {
          this.projectSettings = res.data;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('stopLoad');
      }
    },
    dropdownShouldOpen(VueSelect) {
      if (this.selectedNumber !== null) {
        return VueSelect.open
      }

      return VueSelect.search.length !== 0 && VueSelect.open
    },
    throwSuggestions(event) {
    const phoneValue = event.target.value;
    if (phoneValue.length > 2) {
      clearTimeout(this.timerId); 
      
      this.timerId = setTimeout(() => {
        this.$axios.get('customer_referral/leads/lead_detail', {
          params: {
            sub_project_uuid: this.projectSettings.sub_project_uuid,
            phone: phoneValue 
          }
        }).then(data => {
          this.autocompleteItems = data?.data?.data;
        }).catch(error => {
          console.error('Error fetching suggestions:', error);
        });
      }, 300);
    }
  },
    createLead(otpUUId) {
      let lead = {
        otp_uuid: otpUUId,
        sub_project_uuid: this.projectSettings.sub_project_uuid,
        referral_leads: this.referralLeads.map(referral => ({
          full_name: referral.full_name,
          primary_phone: referral.primary_phone,
          referrer_phone: this.selectedNumber?.phone ?? this.selectedNumber,
          referrer_name: this.selectedNumber.name ?? this.selectedName,
          user_id: this.projectSettings.user_id
        }))
      };
      this.$axios.post(`customer_referral/leads`, { lead: lead })
        .then(res => {
          if (res?.data?.status) {
            this.showResponse = true
            this.selectedNumber = "";
            this.selectedName = "";
            this.autocompleteItems = [];
            this.referralLeads = [{ full_name: "", primary_phone: "" }];
          }
          this.isShowLoader = false;
        })
        .catch(err => {
          this.isShowLoader = false;
          if (err.response.status === 500) {
            this.$swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            this.$swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        })
    },
    validateInput(index) {
      this.referralLeads[index].primary_phone = this.referralLeads[index].primary_phone.toString().replace(/\D/g, "").slice(0, 13); // Only numbers, max 13 digits
    },
  }
  }
</script>

<style>

:root {
  --vs-border-color: #cccccc;
  --vs-border-radius: 4px;
  --vs-font-size: 14px;


/* Dropdown */
--vs-dropdown-bg: #fff;
--vs-dropdown-color: inherit;
--vs-dropdown-z-index: 1000;
--vs-dropdown-min-width: 160px;
--vs-dropdown-max-height: 350px;
--vs-dropdown-box-shadow: 0px 3px 6px 0px var(--vs-colors--darkest);

/* Options */
--vs-dropdown-option-bg: rgb(85 128 160 / var(--tw-text-opacity, 1));
--vs-dropdown-option-color: var(--vs-dropdown-color);
--vs-dropdown-option-padding: 6px 12px;

/* Active State */
--vs-dropdown-option--active-bg: rgb(85 128 160 / var(--tw-bg-opacity, 1));
--vs-dropdown-option--active-color: #fff;

}
[type=search]{
  border-color: transparent !important;
  padding-top: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0 !important;
  padding-left: .75rem !important;
  font-size: .875rem !important;
}
.vs__search, .vs__search:focus {
  box-shadow: none !important;
}
.vs--single > *{
  font-family: "Inter", serif;
}

.vs__dropdown-toggle{
  min-height: 42px;
  padding-left: 3px;
}

.vs__open-indicator{
  display: none;
}

.vs__search::placeholder{
  color: #777;
}

.vs__dropdown-menu li{
  font-size: 14px;
}

.vs--single.vs--open .vs__selected, .vs--single.vs--loading .vs__selected{
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
}

.vs--single .vs__selected{
  font-size: 14px;
}

.backdrop-enter-active,
.backdrop-leave-active {
  transition: opacity 0.5s ease;
}

.backdrop-enter-from,
.backdrop-leave-to {
  opacity: 0;
}

.modalContent-enter-active,
.modalContent-leave-active{
  transition: 0.2s ease;
}

.modalContent-enter-from{
  transform: translateY(100px);
  opacity: 0;
  position: absolute;
}

.modalContent-leave-to{
  transform: translateY(-100px);
  opacity: 0;
  position: absolute;
}

.btn-remove{
  right: -6px;
  top: 54px;
  transform: translate(-50%, -50%);
}

@media (max-width: 767px){
  .btn-remove{
    transform: none;
    top: 0;
    right: 24px;
  }
}

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  /* Firefox */
  input[type="number"] {
      -moz-appearance: textfield;
  }

  /* General (Optional) */
  input[type="number"] {
      appearance: textfield; /* Fallback for other browsers */
  }

</style>